import script from "./BaseLocaleSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseLocaleSelect.vue?vue&type=script&setup=true&lang=ts"

import "./BaseLocaleSelect.vue?vue&type=style&index=0&id=38902ad8&scoped=true&lang=scss"

import exportComponent from "/builds/digithia/escape-game/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38902ad8"]])

export default __exports__